/**
 * Whether this page is on its way out because the signed-in user changed (#7026): the reload has
 * started, but code already queued can still run before the unload.
 *
 * Almost nothing needs to ask. Requests are already blocked and the page hidden
 * (src/lib/reload-on-user-change.ts). What those can't cover is another window: a tab opened
 * before the change and navigated after an await (a signed document link) would show the previous
 * user's content outside this page. Code that navigates such a tab checks this first and closes the
 * tab instead (Codex on #7027).
 *
 * No dependencies, so any component can import it.
 */
let leaving = false;

export function markPageLeaving(): void {
  leaving = true;
}

export function isPageLeaving(): boolean {
  return leaving;
}
